module.exports = __webpack_public_path__ + "static/VTCMarsha-Bold-ad122bd47eb13651b44eff0e25c2a23e.woff";